/**
 * Coming from:
 * https://wiki.stb.intra/pages/viewpage.action?spaceKey=CD&title=Non-anonymous+Tracking+of+Web+Activity
 */
export function generateStbIdCookie(): string {
  return "xxxxxxxx-xxxx-7xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16).toUpperCase();
  });
}
